import { useState } from 'react';
import { useAuth } from '../../../utils/context/AuthContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SimpleLayout from '../../../layouts/SimpleLayout';
import { Button, Spinner } from 'react-bootstrap';
import logo from '../../../assets/img/logo.png';
import { formatAxiosError } from '../../../utils/formatAxiosError';
import { Helmet } from 'react-helmet-async';
import './index.css';
import { IconExclamationCircleFilled, IconEye, IconEyeOff } from '@tabler/icons-react';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const [showPassword, setShowPassword] = useState(false);

    const [authProgress, setAuthProgress] = useState(false);

    const [error, setError] = useState(null);
    const { login } = useAuth();

    const location = useLocation();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setError(null);
            setAuthProgress(true);

            const credentials = {
                username: username,
                password: password,
            };
            const result = await login(credentials);

            if (result.success === true) {
                const targetPath = location.state?.from?.pathname || '/prise-carburant';
                navigate(targetPath, { replace: true });
            } else {
                setError({
                    title: "Echec d'authentification",
                    description: result.message,
                });
            }
        } catch (err) {
            setError({
                title: "Echec d'authentification",
                description: (formatAxiosError(err)?.details?.statusCode === 401 ? 'Identifiants incorrects' : formatAxiosError(err)?.message) ?? "Echec d'authentification",
            });
        } finally {
            setAuthProgress(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>Connexion :: Portail PETROSIL</title>
            </Helmet>

            <div className="auth-page">
                <div aria-hidden="true" />

                <div className="auth-card-container page page-center">
                    <div className="container container-tight py-3">
                        <div className="text-center mb-4">
                            <a href="/" className="navbar-brand navbar-brand-autodark" aria-label="Aller à l'accueil">
                                <img src={logo} alt="Logo PETROSIL" width="130" height="auto" />
                            </a>
                        </div>

                        <div className="card card-md">
                            <div className="card-body">
                                <h2 className="h2 text-center mb-4">Connexion</h2>

                                {error && (
                                    <div className="alert alert-danger alert-dismissible" role="alert">
                                        <div className="alert-icon">
                                            <IconExclamationCircleFilled />
                                        </div>
                                        <div>
                                            <h4 className="alert-heading">{error?.title}</h4>
                                            <div className="alert-description">{error?.description}</div>
                                        </div>
                                        <button className="btn-close" aria-label="Fermer" onClick={() => setError(null)} />
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Nom d'utilisateur <span className="text-danger"> *</span>
                                        </label>
                                        <input type="text" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Nom d'utilisateur" autoFocus required />
                                    </div>

                                    <div className="mb-2">
                                        <label className="form-label d-flex justify-content-between flex-wrap">
                                            <span>
                                                Mot de passe <span className="text-danger">*</span>
                                            </span>

                                            <Link to="/forgot-password" className="fs-5 text-decoration-none mt-1 mt-sm-0" tabIndex={-1}>
                                                Mot de passe oublié ?
                                            </Link>
                                        </label>

                                        <div className="input-group input-group-flat">
                                            <input type={showPassword ? 'text' : 'password'} className="form-control" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />

                                            <span className="input-group-text">
                                                <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer', background: 'none', border: 'none', padding: 0 }} title={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'} className="text-secondary" aria-pressed={showPassword}>
                                                    {!showPassword ? <IconEye /> : <IconEyeOff />}
                                                </button>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="form-footer">
                                        <Button type="submit" disabled={authProgress} className="btn btn-primary w-100">
                                            {authProgress ? (
                                                <>
                                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                    &nbsp; Connexion
                                                </>
                                            ) : (
                                                'Connexion'
                                            )}
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="text-center text-secondary mt-3">
                            Vous n'êtes pas encore client PETROSIL ? <br />
                            <a href="mailto:sales@petrosilrdc.com">Équipe commerciale</a>.
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

Login.Layout = SimpleLayout;

export default Login;
